import { IShopWholesaler } from '@cbgms/api'
import { OrderSystem } from '@cbgms/api/modules/enums'

export { isAxaptaOrderSystem } from '@cbgms/api'

export const isMijnGrossier = (wholesaler?: IShopWholesaler) => {
  if (!wholesaler) return false
  return wholesaler.OrderSystem === OrderSystem.MijnGrossier
}

export const isMijnGrossierOrMgNl = (wholesaler?: IShopWholesaler) => {
  if (!wholesaler) return false
  return wholesaler.OrderSystem === OrderSystem.MijnGrossier || wholesaler.OrderSystem?.toLowerCase() === 'vpom_mgnl'
}

export const isVPOMAXBE = (wholesaler?: IShopWholesaler) => {
  if (!wholesaler) return false
  return wholesaler.OrderSystem?.toLowerCase() === 'vpom_axbelgium'
}
